import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { AuthService } from './auth.service';

export const userInfoResolver: ResolveFn<void> = () => inject(AuthService).whenReady();
